import styled from "styled-components";

import { InquiryOverviewFilterStyle } from "@components/inquiryOverviewFilter/inquiryOverviewFilterStyle";

export const AssetsFilterStyle = styled(InquiryOverviewFilterStyle)``;
